export interface Author {
  id: string;
  name: string;
  role: string;
  badge: string;
  bio: string;
  longBio: string;
  image: string;
  skills: string[];
  topics: string[];
  stats: { value: string; label: string }[];
  social: { icon: string; href: string; label: string }[];
  websiteLabel?: string;
  websiteHref?: string;
}

export const authors: Author[] = [
  {
    id: 'kamil-frajtko',
    name: 'Bc. Kamil Frajtko',
    role: 'Zakladateľ & CEO · Boostio',
    badge: 'Zakladateľ',
    bio: 'Digitálny stratég a zakladateľ Boostio. Spája technickú exekúciu, funkčný dizajn a biznis pohľad - výsledok musí nielen dobre vyzerať, ale aj fungovať v praxi.',
    longBio: 'Bc. Kamil Frajtko je zakladateľom digitálnej agentúry Boostio. Zameriava sa na komplexné digitálne riešenia pre slovenské firmy - od tvorby webov a e-shopov cez SEO a marketingové kampane až po vlastné systémy a automatizácie. Vo svojich článkoch píše o tom, čo skutočne funguje - na základe reálnych výsledkov z projektov, nie teórie. Každý článok vzniká z praxe, z konkrétnych čísel a skúseností zo spolupráce s viac ako 50 klientmi.',
    image: 'https://readdy.ai/api/search-image?query=young%20professional%20Slovak%20man%20Kamil%20confident%20warm%20smile%20business%20casual%20dark%20hair%20clean%20neutral%20studio%20background%20professional%20headshot%20photography%20sharp%20focus%20warm%20lighting&width=600&height=700&seq=kamil-autor-hero&orientation=portrait',
    skills: ['Webový vývoj', 'SEO stratégia', 'Google Ads', 'E-commerce', 'UX & Dizajn', 'Automatizácie', 'Obsahová stratégia', 'Analytika'],
    topics: ['SEO', 'Weby', 'E-commerce', 'PPC Reklama', 'Sociálne siete'],
    stats: [
      { value: '50+', label: 'Projektov' },
      { value: '4+', label: 'Roky skúseností' },
      { value: '5', label: 'Článkov v blogu' },
      { value: '€4.2M+', label: 'Tržieb pre klientov' },
    ],
    social: [
      { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/kamilfrajtko', label: 'LinkedIn' },
      { icon: 'ri-global-line', href: 'https://kamilfrajtko.sk', label: 'Web' },
    ],
    websiteLabel: 'kamilfrajtko.sk',
    websiteHref: 'https://kamilfrajtko.sk',
  },
  {
    id: 'jana-horakova',
    name: 'Jana Horáková',
    role: 'Email Marketing Špecialistka',
    badge: 'Externá autorka',
    bio: 'Špecialistka na email marketing a marketing automatizáciu. Pomáha firmám vybudovať aktívne emaily, ktoré predávajú - nie len zapĺňajú schránky.',
    longBio: 'Jana Horáková je špecialistka na email marketing s viac ako 6 rokmi skúseností v oblasti marketing automatizácie, newsletter stratégie a CRM integrácií. Spolupracuje s Boostio na projektoch, kde je kľúčovým kanálom email a retencia zákazníkov. Vo svojich článkoch odhaľuje konkrétne taktiky, čísla a šablóny, ktoré reálne fungujú na slovenskom trhu.',
    image: 'https://readdy.ai/api/search-image?query=young%20professional%20Slovak%20woman%20Jana%20email%20marketing%20specialist%20confident%20warm%20friendly%20smile%20business%20casual%20clean%20bright%20studio%20background%20portrait%20headshot%20photography%20soft%20light%20sharp%20focus&width=600&height=700&seq=jana-autor-hero&orientation=portrait',
    skills: ['Email Marketing', 'Marketing Automatizácia', 'Newsletter stratégia', 'CRM', 'Segmentácia', 'A/B testovanie', 'Copywriting'],
    topics: ['Email Marketing', 'Automatizácia', 'Newsletter', 'Retencia'],
    stats: [
      { value: '6+', label: 'Roky skúseností' },
      { value: '1', label: 'Článok v blogu' },
      { value: '42:1', label: 'Priemerné ROI kampaní' },
      { value: '80+', label: 'Email kampaní' },
    ],
    social: [
      { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    ],
  },
];

export function getAuthorById(id: string): Author | undefined {
  return authors.find((a) => a.id === id);
}

export function getAuthorByName(name: string): Author | undefined {
  return authors.find((a) => a.name === name);
}
